import { render, staticRenderFns } from "./SearchBarItemConsultant.vue?vue&type=template&id=594af1c2"
import script from "./SearchBarItemConsultant.vue?vue&type=script&lang=js"
export * from "./SearchBarItemConsultant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports